// Shared between the edge proxy (which sets it) and the consent provider
// (which reads it), so the two can never drift apart.
export const CONSENT_REQUIRED_COOKIE = 'fb_consent_required';

// Jurisdictions that require prior opt-in before any non-essential cookie or
// tag can fire (ePrivacy for the EEA/UK, LGPD for Brazil). Everywhere else the
// model is opt-out, so analytics may default to granted and no banner is shown.
export const CONSENT_REQUIRED_COUNTRIES = new Set([
  // EU 27
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  // Rest of the EEA, plus Switzerland and the UK
  'IS',
  'LI',
  'NO',
  'CH',
  'GB',
  // Brazil
  'BR',
]);
